import {DashboardType} from "../../../model/dashboard/types";
import {DashboardConfig} from "../../../model/dashboard/dashboard-config";
import {WidgetConfig} from "../../../model/widget/widget-config";
import {ConditionsLogicalOperator} from "../../../../../model2/conditions/collection";
import {WidgetType} from "../../../model/widget/widget-type";
import {generateUniqueId} from "../../../../../gd/utils/misc/generate-unique-id";

export function projectSummaryConfig() {

    const widgets : any = [
        {

            "title": "Project profile",
            "color": 6,
            "type": "profile-project",
            "settings": {
                // "projectId": "U3PB5q",
                "displayPropertiesFieldsIds": [
                    "statusId",
                    "priority",
                    "statusComments",
                    "health",
                    "startEnd",
                    "deadline",
                    "estimate",
                    "progress"
                ]
            },
            "gridPosition": {
                "y": 0,
                "h": 2,
                "w": 6,
                "x": 0
            },

            "id": generateUniqueId()
        },
        {

            "title": "System status",
            "color": 6,
            "type": "task-chart",
            "settings": {
                "showLegend": true,
                "includeSubFolders": true,
                "includeSubtasks": true,
                "graphType": "donut",
                "counterType": "tasks-total",
                "showClosedTasks": true,
                "projectIds": [
                    // "U3PB5q"
                ],
                "groupBy": "statusId"
            },
            "gridPosition": {
                "y": 2,
                "h": 2,
                "w": 6,
                "x": 0
            },

            "id": generateUniqueId()
        },
        {

            "title": "Project summary",
            "color": 6,
            "type": "project-summary",
            "settings": {
                // "projectId": "U3PB5q"
            },
            "gridPosition": {
                "y": 2,
                "h": 2,
                "w": 3,
                "x": 6
            },

            "id": generateUniqueId()
        },
        {

            "title": "Open tasks",
            "color": 6,
            "type": "line-chart",
            "settings": {
                "reportDate": {
                    "lastDays": 90
                },
                "projectIds": [
                    // "U3PB5q"
                ],
                "counterType": "tasks-total",
                "tasksStatus": "open"
            },
            "gridPosition": {
                "y": 4,
                "h": 2,
                "w": 6,
                "x": 0
            },

            "id": generateUniqueId()
        },
        {

            "title": "Created by",
            "color": 6,
            "type": "task-chart",
            "settings": {
                "showLegend": true,
                "includeSubFolders": true,
                "includeSubtasks": true,
                "graphType": "pie",
                "counterType": "tasks-total",
                "showClosedTasks": true,
                "projectIds": [
                    // "U3PB5q"
                ],
                "groupBy": "createdByUserId"
            },
            "gridPosition": {
                "y": 6,
                "h": 2,
                "w": 6,
                "x": 0
            },

            "id": generateUniqueId()
        },
        {

            "title": "Action required",
            "color": 6,
            "type": "task-chart",
            "settings": {
                "includeSubFolders": true,
                "includeSubtasks": true,
                "graphType": "bar",
                "counterType": "tasks-total",
                "showClosedTasks": false,
                "projectIds": [
                    // "U3PB5q"
                ],
                "groupBy": "actionRequiredUserId"
            },
            "gridPosition": {
                "y": 6,
                "h": 2,
                "w": 6,
                "x": 6
            },

            "id": generateUniqueId()
        },
        {

            "title": "Priority",
            "color": 6,
            "type": "task-chart",
            "settings": {
                "includeSubFolders": true,
                "includeSubtasks": true,
                "graphType": "bar",
                "counterType": "tasks-total",
                "showClosedTasks": false,
                "projectIds": [
                    // "U3PB5q"
                ],
                "groupBy": "priority"
            },
            "gridPosition": {
                "y": 8,
                "h": 2,
                "w": 6,
                "x": 6
            },

            "id": generateUniqueId()
        },
        {

            "title": "Assigned to",
            "color": 6,
            "type": "task-chart",
            "settings": {
                "showLegend": true,
                "includeSubFolders": true,
                "includeSubtasks": true,
                "graphType": "pie",
                "counterType": "tasks-total",
                "showClosedTasks": true,
                "projectIds": [
                    // "U3PB5q"
                ],
                "groupBy": "assignedToUserId"
            },
            "gridPosition": {
                "y": 10,
                "h": 2,
                "w": 6,
                "x": 6
            },

            "id": generateUniqueId()
        },
        {

            "title": "Notes",
            "color": 6,
            "text": null,
            "settings": {
                "displayGrid": true
            },
            "gridPosition": {
                "y": 0,
                "h": 1,
                "w": 1,
                "x": 9
            },
            "type": "quick-notes",

            "id": generateUniqueId()
        }
    ]

    const dashboardConfig:DashboardConfig = {
        "type"      : DashboardType.PROJECT,
        "widgets"   : widgets
    }

    // dashboardConfig.widgets = dashboardConfig.widgets.concat(createWidgets(userId, widgetIds) as any[])

    return dashboardConfig
}


